import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {home: String}

    connect() {
        this.update()
        // Re-run on every Turbo-driven visit
        this.boundUpdate = this.update.bind(this)
        document.addEventListener("turbo:load", this.boundUpdate)
    }

    disconnect() {
        document.removeEventListener("turbo:load", this.boundUpdate)
    }

    update() {
        const atHome =
            window.location.pathname.replace(/\/+$/, "") ===
            (this.homeValue || "/").replace(/\/+$/, "")

        this.element.classList.toggle("nav-gray-bg", atHome)
        this.element.classList.toggle("nav-blue-bg", !atHome)
    }
}